import styles from 'styles/Copyright.module.css';

const Copyright = () => {
  return (
    <div className={styles["copyright"]}>
      ©AREA CUP 
    </div>
  );
};

export default Copyright;
